<template>
  <div class="home">
    
    <button @click="openLoginPage()" class="button is-primary">Button</button>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  mounted:function(){
      this.$router.push({ name: 'Projects', params: { userId: '123' } })

  },
  components: {
    
  },
  methods:{
    openLoginPage(){
      this.$router.push({ name: 'About', params: { userId: '123' } })

    }
  },
}
</script>
